const pt = {
  mte_management: 'Gestão MTE',
  qr_code_reader: {
    no_front_camera: "O seu dispositivo não parece ter câmera frontal",
    no_rear_camera: "O seu dispositivo não parece ter câmera traseira",
    change_camera: "Trocar câmera",
    error_permission: "ERRO: é necessário conceder permissão de acesso à câmera",
    error_no_camera: "ERRO: nenhuma câmera neste dispositivo",
    error_secure_context: "ERRO: contexto seguro necessário (HTTPS, localhost)",
    error_in_use: "ERRO: a câmera já está em uso?",
    error_unsuitable: "ERRO: as câmeras instaladas não são adequadas",
    error_stream_api: "ERRO: a API Stream não é suportada neste navegador",
    error_secure_context_detail: "ERRO: o acesso à câmera só é permitido em contexto seguro. Use HTTPS ou localhost em vez de HTTP.",
    error_generic: "ERRO: erro de câmera ({errorName})",
    invalid_qr_code: "QR Code inválido: não é um ID de trabalho válido"
  },
  select_user_site: "Selecione o site onde o novo usuário atribuído está localizado",
  select_user_site_placeholder: "Selecione o site do usuário",
  select_user_reassign_placeholder: "Selecione um usuário para reatribuir os trabalhos",
  qr_code_viewer: {
    close: "Fechar",
    error_exporting_traveler: "Erro ao exportar o trabalho traveler: {title} - {info}"
  },
  tasks_header: {
    options: "Opções",
    progress: "Progresso",
    save_offline: "Salvar offline",
    sync_job: "Sincronizar trabalho",
    documents: "Documentos",
    copy_from: "Copiar de",
    complete_job: "Concluir trabalho",
    reopen_job: "Reabrir trabalho",
    job_reopened_successfully: "Trabalho reaberto com sucesso",
    failed_reopen_job: "Falha ao reabrir o trabalho",
    complete_job_confirmation: "Algumas tarefas ainda não foram aprovadas. Continuar para concluí-las todas?",
    job_completed_notification: "Trabalho concluído com sucesso. Notificação enviada para {client}"
  },
  documents: "Documentos",
  take_photo: "Tirar foto",
  saved: "Guardado",
  rat_audit_ok: "Todas as peças na tabela RAT foram verificadas pelo controlo de qualidade.",
  rat_audit_fail: "Algumas peças na tabela RAT não foram verificadas pelo controlo de qualidade.",
  upload_rat: "Carregar RAT",
  forbidden_page: {
    message: 'Desculpe, você não tem permissão para ver esta página.',
  },

  page_404: {
    message: '(404) Desculpe, esta página não existe.',
    click: 'Clique',
    here: 'aqui',
    to_return: 'para voltar à página inicial.',
  },

  login_page: {
    digital: 'Digital',
    inspection_jacket: 'Inspection Jacket',
    logging_in: 'Iniciando sessão...',
  },

  dashboard_page: {
    welcome: 'Bem-vindo',
    intro: 'Solução completa para inspeção digital.',
    scan_project_code: 'Digitalizar código do projeto',
    new_version_available: 'Nova versão disponível!',
    websocket_status: 'Estado WebSocket',
    dij_version: 'Digital Inspection Jacket {version}',
    job_checked_out_offline: 'Este trabalho foi retirado para uso offline.',
  },

  header: {
    app_name: 'Digital Inspection Jacket',
  },

  task_page: {
    create_new_task: 'Criar nova tarefa',
    back_to_product_list:
      'Após terminar aqui, volte à Lista de modelos para que outros possam trabalhar neste modelo',
    back_to_work_order_list:
      'Após terminar aqui, volte à Lista de projetos para que outros possam trabalhar nesta ordem',
    drop_file_reference_image: 'Arraste o arquivo aqui ou clique para carregar a Imagem de Referência',
    reference_image: 'Imagem de referência',
    signed_off_by: 'Aprovado por {name}',
    task_not_available_offline: 'Tarefa não disponível offline',
    need_help_chat: 'Precisa de ajuda? Clique aqui para conversar!',
    loading_user_roles: 'Carregando funções do usuário...',
    loading_job_details: 'Carregando detalhes do trabalho...',
    checking_job_status: 'Verificando estado do trabalho...',
    loading_job_tasks: 'Carregando tarefas do trabalho...',
    preparing_tasks: 'Preparando tarefas...',
    deleting_task: 'Eliminando tarefa...',
    duplicating_folder: 'Duplicando pasta...',
    select_folder_to_move: 'Selecione a pasta para mover.',
    select_phase_to_move: 'Selecione a fase para mover a tarefa.',
    change_phase: 'Mudar fase',
    delete_folder_confirmation_message: 'Eliminar uma pasta irá eliminar todas as tarefas dentro dela.',
    delete_confirmation: 'Tem certeza que pretende eliminar?',
  },

  site_edit_permission_denied: 'Não tem permissão para editar sites.',

  create_new_user_page: {
    create_new_user: 'Criar novo usuário',
    create_user: 'Criar usuário',
    firstName: 'Primeiro nome',
    lastName: 'Sobrenome',
    gid: 'GID',
    email: 'E-mail',
    password: 'Senha',
    role: 'Função',
    all_fields_required: 'Por favor, preencha todos os campos obrigatórios.',
    user_failed: 'Falha na criação do usuário.',
    user_success: 'usuário criado com sucesso.',
    password_validation: 'Requisitos da Senha: pelo menos 8 caracteres, uma letra minúscula, uma letra maiúscula, um número, nenhuma parte do seu nome de usuário.'
  },

  change_password_page: {
    change_password: 'Alterar Senha',
    change_user_password: 'Alterar Senha do usuário',
    password_change_success: 'Senha alterada com sucesso',
    secret_question_success: 'Pergunta secreta definida com sucesso',
    password_change_fail: 'Falha ao alterar a Senha.',
    secret_question_fail: 'Falha ao definir a pergunta secreta',
    email: 'E-mail',
    oldPassword: 'Senha antiga',
    password: 'Nova Senha',
    confirmNewPassword: 'Confirmar nova Senha',
    password_should_match: 'A nova Senha e a Senha confirmada devem corresponder.',
    password_validation: 'Requisitos da Senha: pelo menos 8 caracteres, uma letra minúscula, uma letra maiúscula, um número, nenhuma parte do seu e-mail.',
    passwordLowerCase: "A Senha deve conter pelo menos um caractere minúsculo.",
    passwordUpperCase: "A Senha deve conter pelo menos um caractere maiúsculo.",
    passwordNumber: "A Senha deve conter pelo menos um dígito.",
    passwordMinLength: "A Senha deve ter pelo menos 8 caracteres.",
    passwordNoUsernameParts: "A Senha não pode conter partes do nome de usuário."
  },

  profile_page: {
    myProfile: 'O meu perfil',
    account: 'Conta',
    preferences: 'Preferências',
    profileUpdated: 'Perfil atualizado com sucesso',
    updatePreferences: 'Atualizar preferências',
    updateAccount: 'Atualizar conta',
    my_name: 'O meu nome',
    username: 'Nome de usuário',
    email: 'E-mail',
    location: 'Localização',
    phone_number: 'Número de telefone',
    units: 'Unidades',
    inches: 'Polegadas',
    millimetres: 'Milímetros',
  },

  task_view: {
    cancel: 'Cancelar',
    back: 'Voltar',
    save: 'Salvar',
    delete: 'Eliminar',
    deleteConfirmation: 'Tem certeza que pretende <b>eliminar</b> a tarefa <b>{taskTitle}</b>?',
    deleteTask: 'Eliminar tarefa',
    manageMte: 'Registro de instrumentação',
    repairAssessment: 'Avaliação de reparo',
    importAccuScan: 'Importar AccuScan',
    importLaserscan: 'Importar digitalização laser',
    signOff: 'Aprovar',
    orderItem: 'Item de ordem'
  },

  text_size: 'Tamanho do texto',
  selection: 'Seleção',
  alignedlength: 'Comprimento alinhado',
  linearlength: 'Comprimento linear',
  positive_tolerance: '+ Tolerância',
  negative_tolerance: '- Tolerância',

  product_template_list: 'Lista de modelos',
  work_order_list: 'Lista de projetos',
  update: 'Atualizar',
  order: 'Ordem',
  select_folder: 'Selecionar pasta',
  move: 'Mover',
  add_task: 'Adicionar tarefa',
  add_folder: 'Adicionar pasta',
  add_field: 'Adicionar campo',
  message_order_drag: 'Para ordenar as suas tarefas, basta arrastá-las',
  move_folder: 'Mover para pasta',
  move_selected: 'Mover selecionados',
  select: 'Selecionar',
  delete_selected: 'Eliminar selecionados',

  admin: 'Administrador',
  editor: 'Editor',
  publisher: 'Publicador',
  inspector: 'Inspetor',
  report: 'Relatório',
  dashboard: 'Painel',
  profile: 'Perfil',
  language: 'Idioma',
  view_profile: 'Ver perfil',
  manage_fleet_data: 'Gerir dados da frota',
  report_issue: 'Reportar problema',
  request_content: 'Solicitar conteúdo',
  contact_us: 'Contacte-nos',
  forum: 'Viva Engage Forum',
  training: 'Treinamentos',
  log_out: 'Sair da sessão',

  choose_language: 'Escolha o seu idioma.',

  create_new_product: 'Criar novo produto',
  task: 'Tarefa',
  font_size: 'Tamanho da fonte',
  title: 'Título',
  product_line: 'Linha de produto',
  original_OEM: 'OEM original',
  original_oem: 'OEM original',
  brand: 'Marca',
  frame_type: 'Tipo de estrutura',
  model: 'Modelo',
  choose_files: 'Escolher arquivos',
  ocr: 'OCR',
  part_number: 'Número de peça',
  document_number: 'Número de documento',
  revision: 'Revisão',
  cancel: 'Cancelar',
  submit: 'Submeter',
  delete: 'Eliminar',
  save: 'Salvar',
  done: 'Concluído',
  new_product_success: 'Novo produto criado com sucesso.',
  new_order_success: 'Nova ordem criada com sucesso!',
  new_product_fail_message: 'Erro ao criar novo trabalho! Por favor tente novamente.',
  new_order_fail_message: 'Erro ao criar nova ordem! Por favor tente novamente.',
  select_sites: 'Selecionar sites',
  product_created_success: 'Produto criado com sucesso!',
  product_updated_success: 'Produto atualizado com sucesso!',
  template: 'Modelo',
  configuration: 'Configuração',
  sales_force_opportunity_number: 'Número de oportunidade Salesforce',
  select_all_limit_tooltip: 'O botão selecionar tudo adicionará 15 modelos (limite)',
  select_all: 'Selecionar tudo',
  deselect_all: 'Desselecionar tudo',
  select_everything: 'Selecionar tudo',
  deselect_everything: 'Desselecionar tudo',
  import_limit_message: 'Apenas 15 modelos foram importados, o limite foi atingido.',
  sorting_gmtl: 'Ordenação de acordo com GMTL',

  // Tool names inside diagram
  'Selection Tool': 'Ferramenta de seleção',
  'Pan Viewport': 'Mover vista',
  'Diameter': 'Diâmetro',
  'Run-Out': 'Runout',
  'Linear Length': 'Comprimento linear',
  'Visual Inspection': 'Inspeção visual',
  'Text': 'Texto',
  'Generic Measurement': 'Medição genérica',
  'Arrow': 'Seta',
  'Line': 'Linha',
  'Replace Image': 'Substituir imagem',

  // Bubble names
  generic: 'Marcador genérico',
  generic_name: 'Nome genérico',
  runout: 'Runout',
  length: 'Comprimento',
  diameter: 'Diâmetro',
  arrow: 'Seta',
  line: 'Linha',
  text: 'Texto',
  table: 'Tabela',
  replace: 'Substituir imagem',
  visualInspection: 'Inspeção visual',
  visual: 'Inspeção visual',
  'position-image': 'Posicionar imagem',
  'alignedLength': 'Comprimento alinhado',
  'linearLength': 'Comprimento linear',

  // Bubble properties
  label_numbers_only: 'Etiqueta (apenas números)',
  expected_value: 'Valor esperado',
  decimals: 'Decimais',
  units: 'Unidades',
  inch: 'polegada',
  mm: 'mm',
  tolerance_type: 'Tipo de tolerância',
  tolerance: 'Tolerância',
  multiple_positions: 'Múltiplas posições',
  edit_table: 'Editar tabela',
  orientation: 'Orientação',
  measurement_name: 'Nome da medição',
  visual_name: 'Nome da inspeção visual',
  marker_description: 'Descrição',
  generic_marker_tolerance: 'Tolerância',
  direction: 'Direção',
  degrees: 'Graus',
  clock: 'Relógio',
  rotate_text: 'Rodar texto',
  rubbed: 'Esfregado',
  damaged: 'Danificado',
  pitted: 'Picotado',
  eroded: 'Erodido',
  high: 'Alto',
  low: 'Baixo',
  medium: 'Médio',
  acceptable: 'Aceitável',
  all: 'Todos',
  position: 'Posição',
  tir: 'TIR',
  ok: 'Ok',
  in: 'polegada',
  iso_name: 'ISO',
  iso_grade: 'Classe ISO',
  RAT: 'RAT',
  none: 'Nenhum',

  // Save or discard dialog
  save_or_discard_dialog_content: 'Deseja salvar as suas alterações?',
  discard: 'Descartar',
  stay: 'Ficar',
  back: 'Voltar',
  dismiss: 'Fechar',

  import_drawing: 'Importar um desenho',
  work_order_list: 'Lista de projetos',

  edit_name: 'Editar nome',
  reopen: 'Reabrir',

  //Instruction actions
  create_new_item: 'Criar novo item',
  choose_one_item: ' Escolher um item',
  order_item: 'Ordenar item',
  action: 'Ação',
  yes_no: 'Sim/Não',
  options: 'Opção',
  add_iso: 'Adicionar ISO',
  add_calculation: 'Adicionar cálculo',
  recover: 'Recuperar',
  loading: 'Carregando...',
  clear_filters: 'Limpar filtros',
  job_downloaded_locally: 'Trabalho salvo localmente',
  job_has_incomplete_data: 'O trabalho tem dados incompletos',
  job_includes_repair_assessment: 'Este trabalho inclui avaliações de reparo',
  text: 'Texto',
  sap_reference: 'Referência SAP',
  filter: 'Filtro',
  current_owner: 'Proprietário atual',
  current_owner_date: 'Proprietário atual / Data',

  template_list: {
    retrieving_listings: 'Obtendo listagens com base na sua pesquisa...',
    fetched_pages_found: 'Obtidas {batchCount} páginas até agora. Encontradas {size} listagens...',
    found_listings: 'Encontradas {length} listagens que correspondem aos critérios de pesquisa.',
    failed_to_fetch_listings: 'Falha ao obter listagens',
    loading_list: 'A carregar {listName}...',
    loading_list_progress: 'A carregar {listName}... ({processedCount}/{total})',
    loaded_list: 'Carregamento de {listName} concluído',
    loading_job: 'A carregar trabalho...',
    next_page: 'Página seguinte',
    previous_page: 'Página anterior',
    page_label: 'Página',
    current_page: 'Página atual',
    csm_repair_engineer: 'CSM / Engenheiro de reparação',
    warning: "Aviso",
    repair_select_assistant: "Assistente Repair Select",
    how_can_i_help: "Como posso ajudar?",
    no_results_clear_filters: "A pesquisa não retornou resultados. Limpe os filtros para obter dados.",
    checked_out_by: "Retirado por {user}",
    completeness: "Percentual de conclusão: {percentage}%",
    delete_confirmation_title: "ELIMINAR",
    delete_confirmation_message: "Por favor confirme a eliminação de {title}",
    delete_confirm_button: "Eliminar",
    max_favorites_warning: "Só pode adicionar até 140 trabalhos favoritos.",
    job_needs_sync: "O trabalho tem dados que requerem sincronização"
  },

  languages: {
    en: 'Inglês',
    de: 'Alemão',
    pt: 'Português',
    it: 'Italiano',
  },

  copy_from_page: {
    copy_from: "Copiar de",
    copying_tasks_to: "A copiar tarefas para \"{title}\"",
    publisher_tasks: "Tarefas do publicador",
    editor_tasks: "Tarefas do editor",
    search: "Pesquisar...",
    select_all_limit_tooltip: "O botão selecionar tudo adicionará 30 tarefas (limite)",
    select_site: "Selecionar site",
    doc_no: "Número do documento",
    sorting_gmtl_tooltip: "Ordenação de acordo com GMTL",
    work_order: "Ordem de trabalho",
    duplicated_task: "Tarefa duplicada",
    task_already_selected: "A tarefa '{name}' já está selecionada",
    limit_reached: "Apenas {limit} tarefas foram importadas, o limite foi atingido. O último modelo do qual foram importadas tarefas foi: {title}"
  },

  table: 'Tabela',
  import_csv: 'Importar CSV',

  action_requested: 'Ação solicitada',
  picture_taken_is_mandatory: 'É obrigatório tirar uma foto.',
  picture_uploaded_successfully: '{image} carregado com sucesso',
  picture_required: 'Foto obrigatória.',
  your_question: 'A sua pergunta',
  question: 'Pergunta',
  options: 'Opção',
  add_an_option: 'Adicionar uma opção',
  multiple_choice: 'Escolha múltipla',
  single_choice: 'Escolha única',
  text_or_number: 'Texto ou número',

  number_of_rows: 'Número de linhas',
  number_of_columns: 'Número de colunas',
  edit_rows: 'Editar linhas',
  edit_columns: 'Editar colunas',
  only_numbers_and_alphabets: 'Nas células são permitidos apenas números e letras até 16 caracteres',
  table_headings_not_empty: 'Os cabeçalhos da tabela não podem estar vazios',
  upload_diagram: 'Carregar diagrama',

  yes: 'Sim',
  no: 'Não',

  product_template_list: 'Lista de modelos',
  product_line: 'Linha de produto',
  work_order_list: 'Lista de projetos',
  project_list: 'Lista de projetos',
  favorite_list: 'Lista de favoritos',
  search: 'Pesquisar',
  search_ellipsis: 'Pesquisar...',
  add_template: 'Adicionar modelo',
  add_project: 'Adicionar projeto',
  title: 'Título',
  original_OEM: 'OEM original',
  frame_type: 'Tipo de estrutura',
  model: 'Modelo',
  part_number: 'Número de peça',
  location: 'Localização',
  document_number: 'Número de documento',
  revision: 'Revisão',
  created_by: 'Criado por',
  date: 'Data',
  add: 'Adicionar',
  edit: 'Editar',
  delete: 'Eliminar',
  duplicate: 'Duplicar',
  copyfrom: 'Copiar de',
  nothing_here: 'Nada aqui',
  project_number: 'Número de projeto',
  customer: 'Cliente',
  work_order_number: 'Número de ordem de trabalho',
  serial_number: 'Número de série',
  sales_force_number: 'Número Salesforce',
  add_order: 'Adicionar ordem',
  edit_order: 'Editar ordem',
  original_oem_number: 'Número OEM original',
  freefinding: 'Constatação livre',
  csm_label: 'Client Service Manager (CSM) / Project Manager',
  repair_engineer_label: 'Repair Engineer / Project Engineer',

  part_level: 'Nível de peça',
  ignore: 'Ignorar',
  component: 'Componente',
  crop_image: 'Recortar imagem',
  create_rat: 'Criar RAT',
  major: 'Principal',
  minor: 'Secundário',
  select_page: 'Selecionar página {currentPage} de {totalPages}',
  new_product_success_message: 'Novo produto criado com sucesso!',
  new_product_fail_message: 'Erro ao criar novo trabalho! Por favor tente novamente.',
  task_count: 'Contagem de tarefas',
  selection_from_list: 'Se desejar, faça uma seleção da lista',
  select_tasks: 'Selecionar tarefas',
  select_products: 'Selecionar produtos (Opcional)',
  select_all: 'Selecionar tudo',
  deselect_all: 'Desselecionar tudo',
  select_site: 'Selecionar site',
  selected_products: 'Produtos selecionados',
  review: 'Rever',
  sites: 'Sites secundários',
  primary: 'Principal',
  secondary: 'Secundário',
  products: 'Produtos',
  tasks: 'Tarefas',
  next: 'Seguinte',

  sign_off: 'Aprovar',
  sign_off_questions_completed: '{completed}/{total} concluídos.',
  sign_off_diagram_completed: 'Diagrama {percent}% concluído.',
  sign_off_comments_label: 'Por favor insira os seus comentários aqui...',
  number_of_measurement_points: 'Número de pontos de medição',
  stage: 'Fase',
  number_of_stages: 'Número de fases',
  add_job_with_table_message: 'Desculpe, não pode adicionar novos trabalhos pois selecionou um trabalho com uma tabela de tarefas.',
  configure_table_order: 'Configurar tabela',
  no_options_part_level: 'Nenhuma opção encontrada. Se quiser criar uma, escreva "Outro" e selecione.',
  all_configurations_done: 'Todas as configurações neste trabalho estão concluídas',
  finish_configuration: 'Terminar esta configuração',
  configured_jobs: 'Trabalhos configurados',
  version: 'Versão',
  task_completed_message: 'Tarefa já aprovada! Por favor reabra para alterações adicionais!',

  create_task: {
    create_new_task: 'Criar nova tarefa',
    diagram: 'Diagrama',
    instruction: 'Instrução',
    worksheet: 'Folha de trabalho',
    task_name: 'Nome da tarefa',
    cancel: 'Cancelar',
    done: 'Concluído',
    select_software_tool: 'Selecionar ferramenta de software',
  },

  create_folder: {
    create_new_folder: 'Criar nova pasta',
    folder_name: 'Nome da pasta',
    select_software_tool: 'Selecionar ferramenta de software',
    configure_new_part: 'Configurar nova peça',
    draw_no_b_plan: 'Número do desenho',
    draw_no: 'Número do desenho',
    rotor_id: 'ID do rotor',
    parts_list: 'Lista de peças',
    hallmark: 'Marca registrada',
    delete_title: 'ELIMINAR',
    delete_field_confirmation: 'Eliminar campo {label}?',
    name_prompt: 'Nome',
    field_already_exists: 'O campo já existe.',
    failed_create_task: 'Falha ao criar nova tarefa',
    start_of_stages: 'Início das fases',
    end_of_stages: 'Fim das fases',
  },

  emfProductList: {
    'workOrderList': 'Lista de ordens de trabalho',
    'search': 'Pesquisar',
    'addOrder': 'Adicionar ordem',
    'next': 'Seguinte',
    'previous': 'Anterior',

    'productLine': 'Linha de produto',
    'title': 'Título',
    'originalOEM': 'OEM original',
    'frameType': 'Tipo de estrutura',
    'model': 'Modelo',
    'partNumber': 'Número de peça',
    'customer': 'Cliente',
    'projectNumber': 'No projeto',
    'serialNumber': 'No série',
    'workOrder': 'Ordem de trabalho',
    'salesForce': 'No oportunidade Salesforce',
    'createdBy': 'Criado por',
  },

  loginSession: {
    'admin': 'Administrador',
    'editor': 'Editor',
    'publisher': 'Publicador',
    'inspector': 'Inspetor',
    'report': 'Relatório',
    'dashboard': 'Painel',
    'language': 'Idioma',
    'profile': 'Perfil',
    'viewProfile': 'Ver perfil',
    'manageFleetData': 'Gerir dados da frota',
    'reportIssue': 'Reportar problema',
    'requestContent': 'Solicitar conteúdo',
    'contactUs': 'Contacte-nos',
    'training': 'Formação',
    'logOut': 'Terminar sessão'
  },

  404: 'Não encontrado',

  table_template: {
    create_table: 'Criar tabela',
    new_column: 'Adicionar nova coluna',
    new_row: 'Adicionar nova linha',
    delete_column: 'Eliminar coluna selecionada',
    delete_row: 'Eliminar linha selecionada'
  },

  calculation: {
    sum: 'Soma',
    sub: 'Subtrair',
    mult: 'Multiplicar'
  },

  duplicate_work_order_number: 'O número de ordem de trabalho fornecido já está em uso',
  view_qr_code: 'Ver QR Code',
  download_qr_code: 'Baixar QR Code',
  download_traveler: 'Baixar traveler',
  include_repair_assessment: 'Incluir avaliação de reparo',
  repair_assessment: 'Avaliação de reparo',
  import: 'Importar',
  import_editor_template: 'Modelos existentes',
  import_add_excel_file: 'Adicionar de arquivo Excel',
  download_excel_file: 'Baixar arquivo modelo',
  export_task: 'Exportar tarefa',
  saved: 'Guardado',
  not_saved: 'Não guardado',
  level: 'Nível',
  assembly: 'Assemblagem',
  item_number: 'Número do item',
  part_name: 'Nome da peça',
  part_number: 'Número de peça',
  quantity: 'Quantidade',
  serialNumber: 'Número de série',
  actions: 'Ações',
  no_records: 'Sem Registros',
  repair_assessment_empty: 'A avaliação de reparo está vazia. Comece impportando dados ou adicionando-os manualmente',
  repair_assessment_empty_readonly: 'A avaliação de reparo está vazia.',
  close: 'Fechar',
  close_notification: 'Fechar notificação',
  import_add: 'Importar',
  change_log: 'Registro de alterações',

  add_row: 'Adicionar linha',
  remove_row: 'Remover linha',

  repair_assessment_excel_import_failed: 'Falha ao importar avaliação de reparo do arquivo Excel',

  reuse: 'Reutilizar',
  repair: 'Reparar',
  replace: 'Substituir',
  missing: 'Em falta',
  client_reject: 'Rejeitado pelo cliente',
  received: 'Recebido',
  quality_control_override: 'CQ',
  reviewed: 'Rev. Eng.',
  comments: 'Comentários',

  findings: 'Constatações',
  recommendations: 'Recomendações',

  visual: 'Visual',
  dim: 'Dimensional',
  ndt: 'END',

  summary: 'Resumo',
  repair_scope: 'Âmbito da reparo',
  estimated_labor: 'Horas estimadas',

  not_repair_engineer: 'Apenas engenheiros podem rever',

  pre_assembly_audit: 'Auditoria pré-montagem',
  donwload_rat: 'Exportar componentes',
  repair_assessment_search_empty: 'Nenhum item disponível.',

  delete_all: 'Eliminar tudo',
  delete_all_message: 'Isto irá eliminar toda a informação relacionada com a avaliação de reparo existente.',
  delete_major_message: 'Isto irá eliminar a informação dos componentes principais relacionada com a avaliação de reparo.',
  delete_minor_message: 'Isto irá eliminar a informação dos componentes secundários relacionada com a avaliação de reparo.',

  repair_assessment_row_locked: 'Esta linha está bloqueada por {user}',

  feature_disabled: 'Esta funcionalidade está desativada na sua localização',

  locations: 'Localizações',

  recycle_bin: 'Reciclagem',
  recycle_bin_empty: 'A reciclagem está vazia',

  task_name: 'Nome',
  task_type: 'Tipo',
  deleted_by: 'Eliminado por',
  deleted_at: 'Eliminado em',

  executing_site: 'Site de execução',

  na: 'N/D',

  owner: 'Proprietário',

  mtetype_create_title: 'Criar tipo MTE',
  mtetype_update_title: 'Atualizar tipo MTE',

  create: 'Criar',

  name: 'Nome',
  needs_master: 'Requer master',
  is_master: 'É master',

  mte_type_delete_question: 'Tem certeza que pretende eliminar este tipo MTE?',
  mte_type_delete_success: 'Tipo MTE eliminado com sucesso',
  mte_type_delete_fail: 'Falha ao eliminar tipo MTE',

  mte_management: 'Registro de instrumentação',
  add_using_camera: 'Adicionar com câmera',
  close_camera: 'Fechar câmera',
  add_manual_entry: 'Adicionar entrada manual',
  create_external_link: 'Clique para adicionar arquivo/link',
  select_file_to_link: 'Selecione um arquivo para vincular à tarefa',

  id: 'ID',
  type: 'Tipo',
  due_date: 'Data de vencimento',
  master: 'Master',
  created_at: 'Criado em',

  masters: 'Masters',
  non_masters: 'Outros',

  mandatory_error_message: '{field} é obrigatório',
  mandatory_date_must_not_be_in_past_error_message: '{field} é obrigatório e não deve estar no passado',
  unique_error_message: '{field} deve ser único',

  task_locked_by_user: 'A tarefa está bloqueada por {user} até {date}',

  clear: 'Limpar',
  surrogate: 'Substituto',
  stop_surrogating: 'Parar substituição',

  create_new_site_page:
  {
    siteName: 'Nome do site',
    city: 'Cidade',
    state: 'Estado/Região',
    country: 'País',
    create_new_site: 'Criar novo site',
    all_fields_required: 'Por favor, preencha todos os campos obrigatórios.',
    site_failed: 'Falha na criação do site.',
    site_success: 'Site criado com sucesso.',
  },

  edit_site_page:
  {
    edit_site: 'Editar site',
    siteName: 'Nome do site',
    city: 'Cidade',
    state: 'Estado/Região',
    country: 'País',
    rat: 'Ferramenta de avaliação de reparo (RAT)',
    mte_m: 'Registro de instrumentação',
    enable_csm_notifications: 'Ativar notificações de CSM',
    enable_repair_engineer_notifications: 'Ativar notificações de Engenheiro de Reparo',
    delete: 'Eliminar',
    update: 'Atualizar',
    successMessage: 'Site atualizado com sucesso.',
    failedMessage: 'Falha ao atualizar o site.',
    delete_confirm: 'Tem certeza que pretende eliminar este site?',
    deletesite: 'Site eliminado com sucesso.',
    deletefail: 'Falha ao eliminar o site.',
  },
  site_list:
  {
    siteName: 'Nome do site',
    city: 'Cidade',
    state: 'Estado/Região',
    country: 'País',
    DateModified: 'Data de modificação'
  },
  announcement_banner:
  {
    title: 'Banner de anúncios',
    description: 'Configurar o banner de anúncios.',
    status: 'Estado',
    message: 'Mensagem',
    start_date: 'Data de início',
    end_date: 'Data de fim',
    clear_action: 'Limpar',
    preview_action: 'Pré-visualizar',
    save_action: 'Salvar',
    enabled_status: 'Ativado',
    disabled_status: 'Desativado',
    clear_question: 'Isto irá desativar o banner de notificação para todos os usuários. Continuar?',
    end_date_error: 'A data de fim deve ser no futuro'
  },
  edit_user_profile: {
    title: 'Perfil de usuário',
    user_owned_template_count: 'Este usuário é proprietário de {count} Modelos',
    user_owned_job_count: 'Este usuário é proprietário de {count} Trabalhos',
    reassign_jobs: 'Reatribuir trabalhos',
    reassign_templates: 'Reatribuir modelos',
    reassign_jobs_cancel: 'Cancelar reatribuição',
    reassign_job: 'Reatribuir trabalho',
    confirm_reassign: 'Confirmar reatribuição',
    pending_approval_message: 'Este usuário está aguardando aprovação. Verifique as informações do usuário e aprove o perfil para que o usuário possa começar a usar o DIJ',
    rejected_message: 'Este usuário foi rejeitado e não pode acessar o DIJ. O usuário ainda pode ser aprovado se necessário.',
    success_message: 'usuário atualizado com sucesso',
    full_name: 'Nome completo',
    email: 'E-mail',
    primary_location: 'Localização principal',
    secondary_locations: 'Localizações secundárias',
    phone_number: 'Número de telefone',
    role: 'Função',
    power_admin_role: 'Power Admin',
    placeholder_role: 'Função',
    ownership: 'Propriedade',
    additional_permissions: 'Permissões adicionais',
    enginner_review_permission: 'Revisão de engenheiro',
    delete_button: 'Eliminar',
    update_button: 'Atualizar',
    approve_button: 'Aprovar',
    reject_button: 'Rejeitar',
    cancel_button: 'Cancelar',
    approve_question: 'Está aprovando o usuário {name} com a função \'{role}\' e localizações \'{locations}\'. Prosseguir?',
    reject_question: 'Está rejeitando {name}. O usuário não poderá usar o DIJ. Prosseguir?',
    approve_success_message: 'O usuário foi aprovado com sucesso',
    reject_success_message: 'O usuário foi rejeitado com sucesso',
    update_success_message: 'As informações do usuário foram atualizadas com sucesso',
    update_error_message: 'Falha ao atualizar o usuário. Você não tem permissão para editar este usuário.',
    job_reassignment_success_message: 'Os modelos deste usuário foram reatribuídos com sucesso',
  },
  new_user_welcome_page: {
    welcome_configurator_message: 'Bem-vindo ao DIJ. Por favor selecione os sites relevantes para o seu trabalho',
    pending_approval_part1_message: 'O seu pedido de acesso está aguardando aprovação.',
    pending_approval_part2_message: 'Por favor visite mais tarde para obter acesso.',
    submit: 'Submeter',
  },
  user_list: {
    name: 'Nome completo',
    email: 'E-mail',
    location: 'Localização',
    role: 'Função',
    last_login: 'Último acesso'
  },
  users: {
    approved: 'Aprovado',
    approved_description: 'A lista de usuários aprovados. Estes usuários têm acesso total ao DIJ.',
    pending_approval: 'Aprovação pendente',
    pending_approval_description: 'A lista de usuários a aprovar. Estes usuários não podem acessar o DIJ até o seu perfil ser aprovado.',
    todays_logins: 'Acessos de hoje',
    todays_logins_description: 'A lista de usuários que acessaram hoje. Reinicia todos os dias à meia-noite.',
    rejected: 'Rejeitado',
    rejected_description: 'A lista de usuários que durante o processo de aprovação foram rejeitados. Estes usuários não sabem que foram rejeitados.',
    inactive: 'Inativo',
    inactive_description: 'A lista de usuários que não possuem informação SEPIA associada à sua conta.',
  },
  user_picker: {
    label: 'Escolher um usuário',
    placeholder: 'Escreva e selecione usuários disponíveis',
    no_match_found: 'Nenhuma correspondência encontrada',
    email: 'E-mail',
    role: 'Função'
  },

  sign_off_instruction_not_completed: 'Algumas instruções na tarefa não foram totalmente concluídas. Tem certeza que pretende aprovar a tarefa? Isto irá bloquear a tarefa para futuras alterações.',
  sign_off_diagram_not_completed: 'Alguns pontos de inspeção na tarefa não foram concluídos. Tem certeza que pretende aprovar a tarefa? Isto irá bloquear a tarefa para futuras alterações.',

  chat_box: {
    generated_content_warning: 'O conteúdo é gerado automaticamente por IA e pode conter imprecisões',
    type_message_placeholder: 'Escreva a sua mensagem...',
    send: 'Enviar',
    regenerate: 'Regenerar',
    please_wait: 'Por favor aguarde...',
    clear_local_history: 'Limpar histórico local',
    click_to_copy: 'Clique para copiar',
    returning_answer: 'Gerando resposta...',
    summary_generated: 'Resumo gerado!',
  },
  report_template: {
    project_title: 'Título do projeto',
    enter_project_number: 'Inserir número do projeto',
    customer: 'Cliente',
    enter_customer_information: 'Inserir informações do cliente',
    customer_tag: 'Tag do cliente',
    enter_customer_tag: 'Inserir tag do cliente',
    customer_po_no: 'No encomenda do cliente',
    unit_serial: 'Número de série da unidade',
    enter_serial_info: 'Inserir informações de série',
    unit_model: 'Modelo da unidade',
    project_number: 'Número do projeto',
    sales_force_opportunity_number: 'Número de oportunidade Salesforce',
    enter_sales_force_opportunity_number: 'Inserir número de oportunidade Salesforce',
    process: 'Processo',
    enter_process: 'Inserir processo',
    original_order_no: 'No de ordem original',
    enter_original_order_no: 'Inserir No de ordem original',
    previous_orders: 'Ordens anteriores',
    enter_previous_orders: 'Inserir ordens anteriores',
    contact_person_name: 'Nome do contacto',
    enter_contact_person_name: 'Inserir nome do contacto',
    contact_person_department: 'Departamento do contacto',
    executive_summary: 'Sumário executivo',
    generate_executive_summary: 'Gerar sumário executivo',
    repair_select: 'Repair Select',
    sample_text: 'Texto de exemplo:',
    sample_text_content: 'A Siemens prestou serviços técnicos em nome da Duke Energy Carolinas LLC para inspecionar e aconselhar recomendações de reparo para um conjunto de rotor EMM32A3N. O conjunto de rotor foi enviado para as instalações de reparo da Siemens em Charlotte, Carolina do Norte, para uma inspeção de entrada.',
    revision_description: 'Descrição da revisão',
    enter_revision_description: 'Inserir descrição da revisão',
    csm: 'CSM',
    enter_csm: 'Inserir CSM',
    repair_engineer: 'Engenheiro de reparo',
    enter_repair_engineer: 'Inserir engenheiro de reparo',
    major_components: 'Componentes principais',
    minor_components: 'Componentes secundários',
    work_performed_fact_finding: 'Trabalhos realizados para inspeção de levantamento',
    work_performed_repair: 'Trabalhos realizados para reparo',
    repairs_not_completed_recommendations_upgrades: 'Reparações não concluídas, recomendações e melhorias',
    appendix: 'Apêndice',
  },

  report_header: {
    internal_report: 'Relatório interno',
    customer_report: 'Relatório do cliente',
    exclude_items: 'Excluir itens',
    documents: 'Documentos',
    revisions: 'Revisões',
    description: 'Descrição: {description}',
    download: 'Baixar',
    header: 'Cabeçalho',
    deviation_report: 'Relatório de desvios',
    repair_assessment: 'Avaliação de reparo',
    work_performed: 'Trabalhos realizados',
    deleting_report_revision: 'Eliminando revisão do relatório',
    delete_revision_confirmation: 'Tem certeza que pretende <b>eliminar</b> a revisão: {fileName}, descrição: {description}? Esta ação não pode ser desfeita.',
    delete_revision: 'Eliminar revisão',
  },

  report_tasks: {
    table: 'TABELA',
    form_inspection: 'INSPEÇÃO DE FORMULÁRIO',
    document_number: 'Número de documento:',
    revision: 'Revisão:',
    no_records: 'Sem registros',
    item: 'ITEM',
    answer: 'RESPOSTA',
    attachments_uc: 'ANEXO(S)',
    inspector: 'INSPETOR',
    date: 'DATA',
    inspection_diagram: 'DIAGRAMA DE INSPEÇÃO',
    length_measurements: 'MEDIÇÕES DE COMPRIMENTO',
    diameter_measurements: 'MEDIÇÕES DE DIÂMETRO',
    visual_inspection: 'INSPEÇÃO VISUAL',
    generic_measurements: 'MEDIÇÕES GENÉRICAS',
    label_uc: 'Etiqueta',
    part_name_uc: 'Nome da peça',
    description_uc: 'Descrição',
    question_label: 'Pergunta:',
    name_label: 'Nome:',
    description_label: 'Descrição:',
    expected_value_uc: 'Valor esperado',
    tolerance1: 'Tolerância1',
    tolerance2: 'Tolerância2',
    unit: 'Unidade',
    inspector_title: 'Inspetor',
    date_title: 'Data',
    condition: 'Condição',
    severity: 'Severidade',
    measurement_name_uc: 'Nome da medição',
    runout_measurements: 'MEDIÇÕES DE RUNOUT',
    tir: 'TIR',
    tolerance: 'Tolerância',
    task_prefix: 'Tarefa:',
    show_oot_colors: 'Mostrar cores fora de tolerância',
    free_finding: 'CONSTATAÇÃO LIVRE',
    attachments_plain: 'ANEXOS',
    pictures: 'fotos',
    excluded: 'excluído',
  },

  deviation_report: {
    unit_serial: 'Número de série da unidade:',
    review_only: 'Apenas revisão',
    action_required: 'Ação necessária',
    assembly_bom: 'Lista de materiais da assemblagem',
    assembly_ref: 'Referência de assemblagem',
    item_number: 'Item #',
    original_pn: 'PN original',
    actions: 'Ações',
  },

  external_data: {
    title: 'DADOS EXTERNOS',
    upload_failed: 'Falha no carregamento do arquivo',
    item_uc: 'ITEM',
    file_name: 'Nome do arquivo',
    print_to_report: 'Imprimir no relatório',
    file_type_error: 'Este tipo de arquivo não pode ser impresso no relatório',
    delete: 'Eliminar',
    too_many_attachments: 'Demasiados anexos. O máximo permitido é {max} anexos.',
    upload_successful: 'Anexo carregado com sucesso.',
  },

  viewer_3d: {
    downloading_file: 'Baixando arquivo...',
    loading_file: 'Carregando arquivo...',
    screenshot: 'Captura de tela',
    select_task_screenshot: 'Selecione uma tarefa para salvar a captura de tela:',
  },

  findings: {
    title: 'CONSTATAÇÕES',
    by_inspector: 'Pelo inspetor',
    by_reporter: 'Pelo relator',
    placeholder: 'Por favor insira as suas constatações aqui...',
  },

  close_message: 'Fechar mensagem',
  close_banner: 'Fechar banner',
  other: 'Outro',
  enter_an_option: 'Inserir uma opção',
  tap_to_start_writing: 'Toque para começar a escrever',
  breadcrumbs: 'Breadcrumbs',
  close: 'Fechar',

  diagram_builder: {
    repair_icon: 'Ícone de reparo',
    bubble_processing: 'Bolha ainda a ser processada',
    import_diagram: 'Importar um diagrama',
    choose_files: 'Escolher arquivos',
    note_runout_points_missing: 'Nota: o diagrama não contém todos os pontos de runout encontrados no arquivo.',
    note_points_missing: 'Nota: o diagrama não contém todos os pontos encontrados no arquivo.',
    laserscan_import_success: 'Valores do LaserScan importados com sucesso.',
    not_all_dij_points_filled: 'Observação: nem todos os pontos DIJ foram preenchidos.',
    all_inspection_values_imported_successfully: 'Todos os valores de inspeção importados com sucesso.',
    image_size: 'Tamanho da imagem',
    edit_comment: 'Editar comentário',
    comment: 'Comentário',
    your_comment: 'O seu comentário',
    fine: 'Bom',
    major_component: 'Componente principal',
    minor_component: 'Componente secundário',
    label: 'Etiqueta',
    expected: 'Esp.',
    tolerance: 'Tol.',
    empty_diagram: 'Diagrama vazio',
    take_photo: 'Tirar foto',
    tir: 'TIR',
    position_image: 'Posicionar imagem',
    description_options: {
      other: 'Outro',
      te_bearing_journal: 'Mancal TE',
      nte_bearing_journal: 'Mancal NTE',
      te_seal_fit: 'Assento de vedação TE',
      nte_seal_fit: 'Assento de vedação NTE',
      coupling_fit: 'Assento de acoplamento',
      probe_track: 'Pista de sonda',
      bridgeover: 'Ponte',
      thrust_disc_fit: 'Assento do disco de impulso',
      balance_piston: 'Pistão de equilíbrio',
      overspeed_trip_fit: 'Assento de disparo por sobrevelocidade',
      te_gland: 'Gaxeta TE',
      nte_gland: 'Gaxeta NTE',
      '1st_stg_impeller_eye': '1º estágio olho do impelidor',
      '2nd_stg_impeller_eye': '2º estágio olho do impelidor',
      '3rd_stg_impeller_eye': '3º estágio olho do impelidor',
      '4th_stg_impeller_eye': '4º estágio olho do impelidor',
      '5th_stg_impeller_eye': '5º estágio olho do impelidor',
      '6th_stg_impeller_eye': '6º estágio olho do impelidor',
      '7th_stg_impeller_eye': '7º estágio olho do impelidor',
      '8th_stg_impeller_eye': '8º estágio olho do impelidor',
      '1st_2nd_stg_spacer': 'Espaçador 1º-2º estágio',
      '2nd_3rd_stg_spacer': 'Espaçador 2º-3º estágio',
      '3rd_4th_stg_spacer': 'Espaçador 3º-4º estágio',
      '4th_5th_stg_spacer': 'Espaçador 4º-5º estágio',
      '5th_6th_stg_spacer': 'Espaçador 5º-6º estágio',
      '6th_7th_stg_spacer': 'Espaçador 6º-7º estágio',
      '7th_8th_stg_spacer': 'Espaçador 7º-8º estágio',
      journal_area_te: 'Área do mancal TE',
      journal_area_nte: 'Área do mancal NTE',
      thrust_collar_fit: 'Assento do colar de impulso',
      center_balance_plane: 'Plano central de equilíbrio',
      rh_cplg_tpr_fit: 'Assento cónico acoplamento Dir.',
      lh_cplg_tpr_fit: 'Assento cónico acoplamento Esq.',
      extension_fit_te: 'Assento de extensão TE',
      extension_fit_nte: 'Assento de extensão NTE',
      exciter_fit: 'Assento do excitador',
      fan_fit_te: 'Assento do ventilador TE',
      fan_fit_nte: 'Assento do ventilador NTE',
      dummy_piston_fit: 'Assento do pistão fictício',
      oil_deflector_fit_te: 'Assento do defletor de óleo TE',
      oil_deflector_fit_nte: 'Assento do defletor de óleo NTE',
      hydrogen_seal_fit_te: 'Assento de vedação de hidrogénio TE',
      hydrogen_seal_fit_nte: 'Assento de vedação de hidrogénio NTE',
      collector_ring_fit_te: 'Assento do anel coletor TE',
      collector_ring_fit_nte: 'Assento do anel coletor NTE',
      te_brg_seal_area: 'Área de vedação do mancal TE',
      nte_brg_seal_area: 'Área de vedação do mancal NTE',
      thrust_runner_fit: 'Assento do patim axial',
    },
  },

  admin_page: {
    create_new_role: 'Criar nova função',
    new_role_name: 'Nome da nova função',
    select_software_tools: 'Selecionar ferramentas de software',
    edit_role: 'Editar função',
    delete: 'Eliminar',
    update: 'Atualizar',
    cancel: 'Cancelar',
    save: 'Salvar',
    edit: 'Editar',
    features: "Funcionalidades",
    role: "Função",
    role_name: "Nome da função",
    add_role: "Adicionar função",
    add_site: "Adicionar site",
    add_mte_type: "Adicionar tipo MTE",
    needs_master: "Requer master",
    is_master: "É master",
    filter: "Filtro",
    search: "Pesquisar...",
    all: "Todos",
    fixes: "Correções",
    removals: "Remoções",
    permitted_tools: "Ferramentas permitidas",
    date_modified: "Data de modificação",
    user: "usuário",
    sites: "Sites",
    mte_types: "Tipos MTE",
    notification_banner: "Banner de notificações",
    notification_templates: "Modelos de Notificação",
    notification_templates_description: "Crie modelos reutilizáveis para notificações do publisher.",
    add_notification_template: "Adicionar Modelo de Notificação",
    edit_notification_template: "Editar Modelo de Notificação",
    template_name: "Nome do Modelo",
    template_type: "Tipo",
    template_locale: "Idioma",
    template_subject: "Modelo de Assunto",
    template_body: "Modelo de Corpo",
    template_status: "Status",
    template_active: "Ativo",
    template_default: "Padrão",
    template_placeholders_help: "Marcadores disponíveis",
    notification_event_settings_title: "Configurações de eventos de notificação",
    notification_event_settings_description: "Escolha qual modelo deve ser enviado para cada evento de notificação.",
    notification_event_settings_loading: "Carregando eventos...",
    notification_event_settings_no_template: "Sem modelo",
    notification_event_settings_archived_warning: "O modelo atribuído está arquivado. Escolha outro.",
    template_required_fields: "Nome, assunto e corpo são obrigatórios",
    template_saved_successfully: "Modelo salvo com sucesso",
    archive_notification_template_confirm: "Arquivar este modelo de notificação?",
    template_archived_successfully: "Modelo arquivado com sucesso",
    actions: "Ações",
    active: "Ativo",
    archived: "Arquivado",
    archive: "Arquivar",
    instrumentation: 'Instrumentação',
    add_instrumentation: 'Adicionar instrumentação',
    next: "Seguinte",
    back: "Voltar",
    create_role: "Criar função",
    default_role_error: "Desculpe, não pode alterar funções predefinidas.",
    success_default: "Ação concluída com sucesso.",
    failed_default: "Ação falhou. Por favor tente novamente.",
  },

  conflict: {
    title: 'Conflitos de versão detetados',
    yours: 'A sua versão',
    theirs: 'A versão deles',
    done: 'Concluído',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    use_mine_all: 'Usar a minha para tudo',
    use_theirs_all: 'Usar a deles para tudo',
    img_reference: 'Referência de imagem',
    keep_mine: 'Manter a minha',
    use_theirs: 'Usar a deles',
    unknown: 'Desconhecido',
    last_changed_by: 'Última alteração por:',
  },

  instruction_view: {
    create_new: 'Criar novo',
    create_sub_instruction: 'Criar nova sub-instrução',
    table_image_alt: 'Imagem da tabela',
    image_alt: 'Imagem',
    add_option: 'Adicionar uma opção',
    add_other_option: 'Adicionar opção "Outro"',
    manage_options: 'Gerir opções',
    use_image_reference: 'Usar imagem como referência da tarefa',
    upload_image: 'Carregar imagem',
    upload_image_alt: 'Imagem da tabela',
    uploading: 'Carregando...',
    choose_one_item: 'Escolher um item',
    take_photo: 'Tirar foto',
    choose_file: 'Escolher arquivo',
    question: 'Pergunta',
    import: 'Importar',
    table: 'tabela',
    rows: 'Linhas',
    columns: 'Colunas',
    csv_import_note: 'Nota: os cabeçalhos das colunas devem estar na primeira linha do arquivo CSV. A importação funciona apenas para arquivos CSV, não para arquivos Excel.',
    action_option: 'Ação',
    yes_no_option: 'Sim/Não',
    multiple_choice_option: 'Escolha múltipla',
    single_choice_option: 'Escolha única',
    text_number_option: 'Texto',
    table_option: 'Tabela',
    smart_table_option: 'Tabela inteligente',
    import_csv_option: 'Importar tabela CSV',
    done: 'Concluído',
  },

  shared: {
    loading: 'Carregando...',
    no_records: 'Sem registros',
    submit: 'Submeter',
    finish: 'Terminar',
    select_everything: 'Selecionar tudo',
    deselect_everything: 'Desselecionar tudo',
    warning: 'Aviso',
    tasks: 'Tarefas',
    task: 'Tarefa',
    all: 'Todos',
    status: 'Estado',
    signed_off_by: 'Aprovado por',
    signed_off_at: 'Aprovado em',
    percent_complete: '% Concluído',
    tool_bar: 'Barra de ferramentas',
    id: 'ID',
    major_components: 'Componentes principais',
    minor_components: 'Componentes secundários',
    generated_repair_recommendations: 'Gerar recomendações de reparo para esta peça',
    summarize_repair_recommendations: 'Resumir recomendações de reparo',
    shop_notes: 'Notas da oficina',
    serial_number: 'Número de série',
    helpers: 'Assistentes',
    saved: 'Guardado',
    close: 'Fechar',
    documents: 'Documentos',
    upload_attachments: 'Carregar anexos',
    download: 'Baixar',
    upload: 'Carregar',
    leadman_sign_off_required: 'Aprovação do chefe de equipa necessária',
    require_leadman_signing: 'Requerer assinatura do chefe de equipa',
    chat_with_rs: 'Conversar com Repair Select',
    status_complete: 'Concluído',
    status_open: 'Aberto',
  },

  version_page: {
    dij_releases: "Versões DIJ",
    features: "Funcionalidades",
    fixes: "Correções",
    removals: "Remoções",
    improvements: "Melhorias",
    hotfix: "Hotfix",
    updates: "Atualizações",
    version: "Versão",
    date: "Data",
    tag: "Tag"
  },
  common: {
    close: "Fechar",
    save: "Salvar",
    uploading_progress: "Carregando {uploaded}/{total}"
  },
  version_form: {
    title: "Adicionar nova versão",
    version: "Versão",
    date: "Data",
    date_placeholder: "Clique para selecionar uma data",
    section: "Seção",
    section_placeholder: "Selecionar uma seção",
    details: "Detalhes",
    tag: "Tag"
  },
  file_explorer: {
    select_all: 'Selecionar tudo',
    recycle_bin: 'Reciclagem',
    image_gallery: 'Galeria de imagens',
    exclude_images: 'Excluir imagens',
    include_images: 'Incluir imagens',
    attach_images: 'Anexar imagens',
    restore_file: 'Restaurar arquivo',
    root: 'Raiz (/)'
  },
  notifications: 'Notificações',
  notifications_modal: {
    section_selected: 'Seção selecionada',
    watchers: 'Observadores',
    csm: 'Client Service Manager (CSM)',
    repair_engineer: 'Engenheiro de Reparo',
    send_notification: 'Enviar Notificação',
    notification_log: 'Registro de Notificações',
    loading_log: 'Carregando registro de notificações...',
    no_notification_log: 'Nenhuma notificação enviada ainda',
    from: 'De',
    to: 'Para',
    sent_at: 'Enviado',
    template: 'Modelo',
    no_template: 'Sem modelo (mensagem manual)',
    default_template: 'padrão',
    send: 'Enviar',
    add_watchers: 'Adicionar Observadores para este Projeto',
    selected_watchers: 'Observadores Selecionados',
    no_watchers: 'Nenhum observador adicionado ainda',
    notify_users: 'Notificar Usuários',
    role: 'Função',
    search_roles: 'Pesquisar funções...',
    site_label: 'Site',
    role_users_for_site: 'Usuários na função selecionada para este site do job',
    no_role_users_for_site: 'Nenhum usuário encontrado para essa função neste site',
    csm: 'CSM',
    repair_engineer: 'Engenheiro de Reparo',
    not_assigned: 'Não Atribuído',
    other_users: 'Outros Usuários',
    select_users: 'Selecionar Usuários Adicionais',
    note: 'Nota',
    notification_message: 'Mensagem de Notificação',
    template_preview: 'Pré-visualização do Modelo',
    no_template_preview: 'Selecione um modelo para visualizá-lo aqui',
    recipients: 'Destinatários',
    exclude_recipient: 'Excluir destinatário',
    add_recipient: 'Adicionar Destinatário',
    auto_included_from_site_setting: 'Este destinatário será incluído automaticamente com base nas configurações de notificação do site',
    search_users: 'Pesquisar usuários...',
    add_me_as_watcher: 'Adicionar-me como observador',
    remove_me_from_watchers: 'Remover-me dos observadores',
    active_watchers: 'Observadores ativos',
    available_placeholders: 'Marcadores disponíveis',
    auto_short: 'auto',
    notification_history: 'Histórico de notificações',
    search_notifications: 'Pesquisar notificações...',
    no_matching_notifications: 'Nenhuma notificação correspondente encontrada.',
    items_count: '{filtered} / {total} item(ns)',
    remove: 'Remover',
    watchers_updated: 'Observadores atualizados com sucesso',
    notification_sent: 'Notificação enviada com sucesso'
  }
};

export default pt;
